<template>
    <div>
        <van-popup v-model="showPopupStatus" round position="bottom" :style="{ height: '220px' }">
            <div class="popup-content" :class="{ 'show-Qtcode': !showQTCode }">
                <div class="popup-item">
                    <a href="tel:+85229796988">
                        <img src="../assets/images/fundAccount/HK_Phone.png" alt="香港客服电话" />
                        <div class="title">{{ $t('hkCustomerServiceHotline') }}</div>
                    </a>
                </div>
                <div class="popup-item">
                    <a href="tel:4008889288">
                        <img src="../assets/images/fundAccount/CH_Phone.png" alt="大陆客服电话" />
                        <div class="title">{{ $t('mainlandCustomerServiceHotline') }}</div>
                    </a>
                </div>
                <div v-if="showQTCode" class="popup-item" @click="showQRCodePopup">
                    <img src="../assets/images/fundAccount/WeCom.png" />
                    <div class="title">{{ $t('weChatBusiness') }}</div>
                </div>
            </div>
            <van-button @click="showPopup" class="popup-cancel" block>{{ $t('cancel') }}</van-button>
        </van-popup>
        <QrCodePopup :show.sync="QRCodePopupStatus" />
    </div>
</template>

<script>
import QrCodePopup from './QrCodePopup.vue'
import { getClientlist } from '@/apis/modules/uc'

export default {
    name: 'ServicePopup',
    components: {
        QrCodePopup,
    },
    props: {
        show: Boolean,
    },
    data() {
        return {
            QRCodePopupStatus: false,
            showQTCode: false,
        }
    },
    computed: {
        showPopupStatus: {
            get() {
                if (this.show) {
                    // 如果弹窗要显示
                    this.getQRCode() // 触发接口请求
                }
                return this.show
            },
            set(val) {
                this.$emit('update:show', val)
            },
        },
    },
    mounted() {},
    methods: {
        // 展示弹窗
        showPopup() {
            this.showPopupStatus = !this.showPopupStatus
        },
        //  展示二维码弹窗
        showQRCodePopup() {
            this.QRCodePopupStatus = !this.QRCodePopupStatus
        },
        async getQRCode() {
            try {
                const getUserInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
                const cltId = getUserInfo?.clientInfo?.accts?.[0]?.cltId || ''

                if (!getUserInfo || !Number(localStorage.getItem('uin'))) {
                    this.showQTCode = false
                    return
                }

                const params = {
                    uin: Number(localStorage.getItem('uin')),
                    cltId,
                }
                const { data } = await getClientlist(params)
                const result = data?.result || []
                const hasValidQrCode = result.some(item => item.qrCode)
                if (hasValidQrCode) {
                    this.showQTCode = true
                }
            } catch (e) {
                console.error('UserAdvisorList===>error:', e)
            }
        },
    },
}
</script>

<style scoped lang="less">
.popup-content {
    display: flex;
    justify-content: space-between;
    height: 76px;
    margin: 30px auto;
    padding: 0 24px;

    .popup-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        a {
            display: flex; /* 使 <a> 标签变为块级元素，方便布局 */
            flex-direction: column;
            align-items: center;
            color: black;
            text-decoration: none; /* 去除下划线 */
            img {
                width: 48px;
                height: 48px;
            }

            .title {
                margin-top: 8px;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0%;
            }
        }

        img {
            width: 48px;
            height: 48px;
            margin: 0 15px;
        }

        .title {
            margin-top: 8px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0%;
        }
    }
}

.show-Qtcode {
    padding: 0 55.5px;
}

.popup-cancel {
    border: none;
    border-top: 1px solid #e6e6e6;
}
</style>
